import { cn } from '../../utils/classNames';
import PaginationNavigation from '../ui-control/PaginationNavigation';
import PaginationSummary from '../ui-control/PaginationSummary';

const rowClasses = 'flex justify-between items-center';

const Pagination = ({
  currentPage,
  handlePageChange,
  totalCount,
  handlePageSizeChange,
  limit,
  className,
}) => {
  const totalPages = limit > 0 ? Math.ceil(totalCount / limit) : 0;
  const startEntry = totalCount === 0 ? 0 : (currentPage - 1) * limit + 1;
  const endEntry = Math.min(currentPage * limit, totalCount);

  return (
    <div className={cn(rowClasses, className)}>
      <PaginationSummary
        startEntry={startEntry}
        endEntry={endEntry}
        totalCount={totalCount}
        pageSize={limit}
        onPageSizeChange={handlePageSizeChange}
      />
      {totalPages > 1 && (
        <PaginationNavigation
          handlePageChange={handlePageChange}
          currentPage={currentPage}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};

export default Pagination;
